import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.48 7.414a2.914 2.914 0 1 1 5.829 0 2.914 2.914 0 0 1-5.829 0M12.394 3a4.414 4.414 0 1 0 0 8.828 4.414 4.414 0 0 0 0-8.828m-1.687 10.386A6.707 6.707 0 0 0 4 20.093v.347a.75.75 0 0 0 1.5 0v-.347a5.207 5.207 0 0 1 5.207-5.207h3.376a5.207 5.207 0 0 1 5.207 5.207v.347a.75.75 0 0 0 1.5 0v-.347a6.707 6.707 0 0 0-6.707-6.707z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }